'use strict';

/*exported jeditableChangeDateTo*/
function jeditableChangeDateTo($input) {
  $input.closest('td').find('.icon').html('<i class="glyphicon glyphicon-question-sign text-muted"></i>');
}
